import axios from 'axios'
import { API_URL } from '@/constants/urls'

const request = axios.create({
  baseURL: API_URL
  // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  // headers: { 'Content-Type': 'application/json' }
  // headers: { Accept: 'application/json' }
  // withCredentials: true
})

request.interceptors.request.use(
  (response: any) => response,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (error: any) => {
    return // Sentry.captureException(error);
  }
)

export default request
